export default __webpack_public_path__ + "static/media/vishakha-logo.7e35b9e4.png";